import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/entities/Session';
import { useUserStore } from '@/entities/User';
import { useBranchTheme } from '@/entities/Branch';
import { useCustomToast, useTheme } from '@/shared/lib';
import { useDocumentSelection } from '@/features/Document';
import { routes } from './routes';
import { navigationGuard } from './guards/navigation.guard';
import { resetVisibleDirectoryTreeCache } from '@/pages/home';

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(navigationGuard);

export function clearAuthState(): void {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const { resetSelection } = useDocumentSelection();
  const { clearTheme } = useTheme();
  const { clearSelectedBranch } = useBranchTheme();

  authStore.clearAuthenticationState();
  userStore.clearUser();
  resetSelection();
  clearTheme();
  clearSelectedBranch();
  resetVisibleDirectoryTreeCache();
}

const toast = useCustomToast();
export function showErrorToast(
  title: string,
  message: string,
  timeout: number | false = 4000
): void {
  toast.showErrorToast({ title, message, type: 'error' }, { timeout });
}
